import React from 'react';
import PropTypes from 'prop-types';
import { getOptionLabel } from '../../shared/lib';

export default function SubmissionFieldChoice({ context, question, value }) {
  return (
    <ul>
      {(Array.isArray(value) ? value : [value]).map((val, i) => (
        <li key={i}>{getOptionLabel(question.config.options, val)}</li>
      ))}
    </ul>
  );
}

SubmissionFieldChoice.propTypes = {
  context: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
};
